import CodeMirror from "codemirror";

export default class EmailTester{

  constructor(){
    const templateSelect = document.querySelector('#template-select');
    const emailInput = document.querySelector('.js-email-input');
    const wrapper = document.querySelector('.sendEmail-wrapper');
    let editor;

    window.__templates__={};
    $("#template-select option").each(function(i){
      if(i > 0) {
        window.__templates__[this.value] = [this.dataset.url];
      }
    });
    if (document.getElementById('editor')) {
      setTimeout(() => {

        editor = CodeMirror.fromTextArea(document.getElementById('editor'), {
          lineNumbers: true,
          mode: 'text/x-yaml',
          scrollbarStyle: "null"
        });
        editor.refresh();
        document.querySelector('.CodeMirror-sizer').style.marginLeft = "2px";
        editor.setSize(null, 230);
        templateSelect.addEventListener('change', (e) => {
          editor.setValue(window.__templates__[e.target.value][0]);
        });

      }, 1000);
    }

    const howToBtn = document.querySelector('.js-how-to');
    const howToCnt = document.querySelector('.js-how-to-info');
    if(howToBtn){
      howToBtn.addEventListener('click', () => {
        if (howToCnt.style.display === '') {
          howToCnt.style.display = 'none';
        } else {
          howToCnt.style.display = '';
        }
      });
    }

    const sendEmail =  document.querySelector('#send-email');
    if(sendEmail){
      sendEmail.addEventListener('click', (e) => {
        $('.js-sending').removeClass("d-none");
        $('.js-ok').hide();
        $('.js-error').hide();
        $.ajax({
          // url: `/o/${e.target.dataset.orgname}/email-tester/send`,
          url: wrapper.getAttribute('data-url'),
          data: {
            template: templateSelect.value,
            email: emailInput.value,
            values: editor.getValue(),
          },
          type: 'post',
          success() {
            $('.js-sending').hide();
            $('.js-ok').removeClass("d-none").show();
          },
          error(err) {
            $('.js-sending').hide();
            $('.js-error').removeClass("d-none").show();
            if(err.responseJSON) {
              document.querySelector('.js-error').innerHTML = 'Error: ' + err.responseJSON.error;
            }
          }
        });
      });
    }
  }
}
